import { model as router } from '!/router'
import { model as popupModel } from '$/info-popup'
import { createEvent, restore, sample } from 'effector'
import { type VodsParams } from './lib'

export const selectVod = createEvent<VodsParams>()
const redirectToVodDetailsPage = createEvent<VodsParams | null>()

export const $selectedVod = restore(selectVod, null)

sample({
  clock: selectVod,
  filter: ({ locked }) => !locked,
  target: redirectToVodDetailsPage,
})

sample({
  clock: selectVod,
  filter: ({ locked }) => locked,
  fn: ({ id, name, locked }) => ({
    ...popupModel.emptyPinLockState,
    id,
    name,
    locked,
  }),
  target: popupModel.openPinLockPopup,
})

sample({
  clock: popupModel.updateUnlockId,
  source: {
    selectedVodParams: $selectedVod,
  },
  filter: ({ selectedVodParams }, unlockedId) =>
    unlockedId === selectedVodParams?.id,
  fn: ({ selectedVodParams }) => selectedVodParams,
  target: redirectToVodDetailsPage,
})

sample({
  clock: redirectToVodDetailsPage,
  fn: (movieParams) => {
    if (!movieParams) {
      return '/movies'
    }

    const { vodIndex, id, categoryId } = movieParams

    return typeof vodIndex === 'number'
      ? `/movies/${id}?categoryId=${categoryId || 0}&vodIndex=${vodIndex}`
      : `/movies/${id}?categoryId=${categoryId || 0}`
  },
  target: router.navigatePush,
})
